import { motion } from "framer-motion";
import { IMAGES } from "@/data/content";
import { Reveal } from "./Reveal";

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32 px-6 md:px-10 bg-cream" data-testid="about-section">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <Reveal>
          <div className="relative group">
            <div className="absolute -top-5 -left-5 w-28 h-28 border border-gold/40 rounded-3xl transition-transform duration-700 group-hover:rotate-6" />
            <div className="relative rounded-[2rem] overflow-hidden h-[480px] shadow-[0_30px_60px_-20px_rgba(48,66,56,0.35)]">
              <img
                src={IMAGES.about}
                alt="Une présence de confiance au quotidien"
                className="w-full h-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
              />
            </div>
            <motion.div
              animate={{ y: [0, -10, 0] }}
              transition={{ duration: 4.5, repeat: Infinity, ease: "easeInOut" }}
              className="absolute -bottom-6 -right-6 glass rounded-2xl px-6 py-4 shadow-lg"
            >
              <div className="font-display text-3xl text-forest font-semibold">+ 15 ans</div>
              <div className="text-xs text-forest/60">d’expérience humaine</div>
            </motion.div>
          </div>
        </Reveal>

        <Reveal delay={0.1}>
          <span className="text-xs font-semibold uppercase tracking-[0.25em] text-gold">Notre philosophie</span>
          <h2 className="mt-5 font-display text-4xl sm:text-5xl font-normal tracking-tight text-forest leading-[1.1]">
            Une présence de confiance au quotidien
          </h2>
          <p className="mt-7 text-base md:text-lg text-forest/75 leading-relaxed">
            Chez Proxilia, nous croyons que le bien-être passe par l’autonomie, la sécurité et le lien social. Nous accompagnons les seniors dans leurs démarches, leurs loisirs et leurs besoins du quotidien avec discrétion, bienveillance et professionnalisme.
          </p>
          <div className="mt-9 grid sm:grid-cols-3 gap-6">
            {[
              { t: "Autonomie", d: "Préserver l’indépendance" },
              { t: "Sécurité", d: "Veiller à chaque instant" },
              { t: "Lien social", d: "Cultiver les rencontres" },
            ].map((v) => (
              <div key={v.t} className="border-l-2 border-sage/40 pl-4">
                <div className="font-cormorant text-2xl text-forest font-medium">{v.t}</div>
                <div className="text-sm text-forest/60 mt-1">{v.d}</div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
